import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {PageHeader} from "../../../components/PageHeader";
import NotificationListType from "./subPage/NotificationListType";
import NotificationThumbType from "./subPage/NotificationThumbType";
import useRequestData from "../../../hooks/useRequestData";
import {getNotificationConditions, getNotificationsBySearch} from "../../../api/alarm/notificationService";

/**
    환경설정 - 알람관리 - 요청발송내역
 */
const Notifications = () => {
    const [listType, setListType] = useState(true);
    const dp = useDispatch();

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    const [conditions, setConditions] = useState({
        alamContentCategories: [], alarmType: []
    });

    const handleCallConditions = async () => {
        const response = await getNotificationConditions();
        if (response && response.status === 200) {
            setConditions({
                alamContentCategories: response.data.alamContentCategories.map(({ name, value }) => ({ name, id: value })),
                alarmType: response.data.alarmTypes.map(({ name, value }) => ({ name, id: value })),
            });
        }
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }

        handleCallConditions();
    }, []);


    const {newData, pageInfo, dataHook} = useRequestData(getNotificationsBySearch, initDate, "notification");

    return (
        <div className="common-container container-height-full">
            <PageHeader header={"요청발송내역"} indicator={"환경설정 > 알람관리 > 요청발송내역"}/>
            {listType ?
                <NotificationListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} conditions={conditions} />
                :
                <NotificationThumbType />
            }
        </div>
    );
};

export default Notifications;
